import { lazy } from "react"
import type { FC, LazyExoticComponent } from "react"

async function loader(): Promise<{ default: FC }> {
    return import("./assistant.swap-session.page").then(({ AssistantSwapSessionPage: SSP }): { default: FC } => ({
        default: SSP
    }))
}

const AssistantSwapSessionPage: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => loader())

export { AssistantSwapSessionPage }

async function assistantSwapSessionPagePreloader(): Promise<void> {
    await loader()
}

export { assistantSwapSessionPagePreloader }
